module.exports = __webpack_public_path__ + "img/rj_section_bg.2cc3cd08.png";